import { useState, useEffect } from "react";
import { loadBillOfMaterialCode } from "../services/billOfMaterialService";

const useBillOfMaterialCode = (editID) => {
    const [materialCode, setMaterialCode] = useState([]);    
    const [isMaterialCodeDataLoaded, setIsMaterialCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialCode = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadBillOfMaterialCode(para);
            if (data && data.length > 0) {
                setMaterialCode(data[0].bom_code);         

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCodeDataLoaded && editID === 0) {
            fetchMaterialCode();
        }
    }, [isMaterialCodeDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMaterialCodeByID = async (selectedID) => {        
        await fetchMaterialCode(selectedID);
    };

    return {
        materialCode,
        setMaterialCode,        
        loadMaterialCodeByID,
    };
};

export default useBillOfMaterialCode;
